import { Box } from "@mui/material";

/**
 * utils de opciones para Orden.js, Modify.js y Archive.js in case origin marketing
 *
 * @returns {Object} Propiedades del componente.
 * @property {img} Box img - Imagen para identificar  tipos de origen de Marketing
 * @property {text} label Label identificando tipos de marketing
 */
export const origenMarketingOptions = [
  // {
  //   icon: (
  //     <Box
  //       component="img"
  //       src="https://movicaremx.com/IMG/app_mobile/FormatPNG/vocacion%20de%20servicio.png"
  //       alt="Alianzas"
  //       width={30}
  //       height={30}
  //     />
  //   ),
  //   label: "Alianzas",
  //   id: 1,
  // },
  // {
  //   icon: (
  //     <Box
  //       component="img"
  //       src="https://movicaremx.com/IMG/Sitioweb/Movicare_cuadrado.png"
  //       alt="Aplicación móvil"
  //       width={30}
  //       height={30}
  //     />
  //   ),
  //   label: "Aplicación móvil",
  //   id: 2,
  // },
  // {
  //   icon: (
  //     <Box
  //       component="img"
  //       src="https://movicaremx.com/IMG/administrador/Campañas.png"
  //       alt="Campañas"
  //       width={30}
  //       height={30}
  //     />
  //   ),
  //   label: "Campañas",
  //   id: 3,
  // },
  {
    icon: (
      <Box
        component="img"
        src="https://movicaremx.com/IMG/administrador/Cortesia.png"
        alt="Garantia de servicio"
        width={30}
        height={30}
      />
    ),
    label: "Garantia de servicio",
    id: 4,
  },
  {
    icon: (
      <Box
        component="img"
        src="https://movicaremx.com/IMG/app_mobile/FormatPNG/confianza.png"
        alt="Cliente frecuente"
        width={30}
        height={30}
      />
    ),
    label: "Cliente frecuente",
    id: 5,
  },
  {
    icon: (
      <Box
        component="img"
        src="https://movicaremx.com/IMG/app_mobile/FormatPNG/empresas.png"
        alt="Empresas"
        width={30}
        height={30}
      />
    ),
    label: "Empresas",
    id: 6,
  },
  // {
  //   icon: (
  //     <Box
  //       component="img"
  //       src="https://movicaremx.com/IMG/app_mobile/FormatPNG/escuelas.png"
  //       alt="Escuelas"
  //       width={30}
  //       height={30}
  //     />
  //   ),
  //   label: "Escuelas",
  //   id: 7,
  // },
  // {
  //   icon: (
  //     <Box
  //       component="img"
  //       src="https://movicaremx.com/IMG/app_mobile/FormatPNG/eventos%20sociales.png"
  //       alt="Eventos"
  //       width={30}
  //       height={30}
  //     />
  //   ),
  //   label: "Eventos",
  //   id: 8,
  // },
  {
    icon: (
      <Box
        component="img"
        src="https://movicaremx.com/IMG/app_mobile/FormatPNG/clinicas%20y%20hospitales.png"
        alt="Clínicas"
        width={30}
        height={30}
      />
    ),
    label: "Clínicas",
    id: 9,
  },
  {
    icon: (
      <Box
        component="img"
        src="https://movicaremx.com/IMG/app_mobile/FormatPNG/Sociales/Icono_face.png"
        alt="Facebook"
        width={30}
        height={30}
      />
    ),
    label: "Facebook",
    id: 10,
  },
  {
    icon: (
      <Box
        component="img"
        src="https://movicaremx.com/IMG/app_mobile/FormatPNG/Perfil/Ajolomovi_H.png"
        alt="Familiar Movi"
        width={30}
        height={30}
      />
    ),
    label: "Familiar Movi",
    id: 11,
  },
  {
    icon: (
      <Box
        component="img"
        src="https://centromedicomedam.com/IMG/Logos/isologo_color_MEDAM.png"
        alt="Familiar HF"
        width={35}
        height={35}
      />
    ),
    label: "Familiar OHF/MEDAM",
    id: 12,
  },
  {
    icon: (
      <Box
        component="img"
        src="https://movicaremx.com/IMG/HFUTURA/LCD%202021-03.png"
        alt="Familiar DULAB"
        width={35}
        height={30}
      />
    ),
    label: "Familiar DULAB",
    id: 13,
  },
  {
    icon: (
      <Box
        component="img"
        src="https://movicaremx.com/IMG/app_mobile/FormatPNG/Sociales/WhatsApp.png"
        alt="WhatsApp"
        width={30}
        height={30}
      />
    ),
    label: "WhatsApp",
    id: 14,
  },
  {
    icon: (
      <Box
        component="img"
        src="https://movicaremx.com/IMG/app_mobile/FormatPNG/Sociales/Instagram.png"
        alt="Instagram"
        width={35}
        height={35}
      />
    ),
    label: "Instagram",
    id: 15,
  },
  // {
  //   icon: (
  //     <Box
  //       component="img"
  //       src="https://movicaremx.com/IMG/app_mobile/FormatPNG/Services/Promocion.png"
  //       alt="Promoción"
  //       width={30}
  //       height={30}
  //     />
  //   ),
  //   label: "Promoción",
  //   id: 16,
  // },
  // {
  //   icon: (
  //     <Box
  //       component="img"
  //       src="https://movicaremx.com/IMG/administrador/Cortesia.png"
  //       alt="Cortesía"
  //       width={30}
  //       height={30}
  //     />
  //   ),
  //   label: "Cortesía",
  //   id: 17,
  // },
  // {
  //   icon: (
  //     <Box
  //       component="img"
  //       src="https://movicaremx.com/IMG/administrador/Web.png"
  //       alt="Web"
  //       width={30}
  //       height={30}
  //     />
  //   ),
  //   label: "Web",
  //   id: 18,
  // },
  {
    icon: (
      <Box
        component="img"
        src="https://movicaremx.com/IMG/Sitioweb/Telefono.png"
        alt="Llamadas"
        width={30}
        height={30}
      />
    ),
    label: "Llamadas",
    id: 19,
  },
  {
    icon: (
      <Box
        component="img"
        src="https://centromedicomedam.com/IMG/styled_icons/Navbar/doctors.png"
        alt="Médico"
        width={30}
        height={30}
      />
    ),
    label: "Médico",
    id: 20,
  },
];
